// src/icons/HeartIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function HeartIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 18,
    viewBox: "0 0 20 18",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M16.4294 3.43818C14.9754 1.965 12.6226 1.965 11.1686 3.43818C10.9889 3.62027 10.8317 3.81581 10.6966 4.02143C10.5426 4.25606 10.2807 4.39737 10 4.39737C9.71936 4.39737 9.45752 4.25606 9.30346 4.02143C9.16845 3.81581 9.01123 3.62027 8.83151 3.43818C7.37751 1.965 5.0247 1.965 3.57071 3.43818C2.11717 4.9109 2.17005 7.38958 3.56879 8.79755C4.42767 9.66208 6.18447 11.4421 7.72536 13.0047C8.49607 13.7863 9.21316 14.5139 9.73757 15.0461L10 15.3125L10.2625 15.0461C10.7869 14.5139 11.504 13.7863 12.2747 13.0047C13.8156 11.4421 15.5724 9.66208 16.4313 8.79755C17.83 7.38958 17.8829 4.91089 16.4294 3.43818ZM10 16.5C9.40633 17.0847 9.40631 17.0847 9.40627 17.0847L8.55039 16.2159C8.02608 15.6838 7.30914 14.9563 6.53862 14.1749C4.99707 12.6116 3.24265 10.8341 2.38642 9.97218C0.354947 7.92732 0.277459 4.40226 2.3845 2.26741C4.48521 0.138988 7.89205 0.133048 10 2.24959C12.1081 0.133047 15.5149 0.138987 17.6156 2.26741C19.7226 4.40226 19.6451 7.92732 17.6137 9.97218C16.7575 10.8341 15.003 12.6116 13.4615 14.1749C12.691 14.9563 11.974 15.6838 11.4497 16.2159L10.5947 17.0837L10.594 17.0845C10.594 17.0845 10.5938 17.0847 10 16.5ZM10 16.5L10.594 17.0845C10.4374 17.2435 10.2233 17.3333 10 17.3333C9.77684 17.3333 9.5629 17.2437 9.40627 17.0847L10 16.5Z",
        fill: "currentColor"
      })
    ]
  });
}
export {
  HeartIcon
};
//# sourceMappingURL=HeartIcon.mjs.map